import querystring from 'querystring';
import { getCookie, setCookie, getCached, setCached, clearCache, getRequestSettings, MD5 } from '_utils';

const cacheCookieKey = 'LAST_CACHE_TIME';

export function get(slug, params, type, successType, errorType, cache = true) {
  return (dispatch) => {
    let url = `${process.env.REACT_APP_API_ENDPOINT_BASE_URL}/api/thunderbolt/${slug}`;
    if (params !== undefined) {
      url += '?';
      url += querystring.stringify({ ...params });
    }
    const cacheKey = `${slug}=${MD5(JSON.stringify(params))}`;


    // Dispatch the initial type (used for ..loading)
    dispatch({
      type,
    });

    const cachedValue = getDataFromCache(cacheKey);

    if (cachedValue !== null) {
      return dispatch({
        type: successType,
        payload: { data: cachedValue, params },
      });
    }

    return fetch(url, getRequestSettings('GET'))
      .then((res) => {
        if (!res.ok) {
          throw Error(res.statusText);
        }

        return res.json();
      })
      .then((data) => {
        if (cache === true) {
          setDataInCache(cacheKey, data);
        }
        dispatch({
          type: successType,
          payload: { data, params },
        });
      })
      .catch((error) => {
        console.log(error);
        clearCache(cacheKey);
        dispatch({
          type: errorType,
          payload: error,
        });
      });
  };
}

export function post(slug, params, type, successType, errorType, cache = true) {
  return (dispatch) => {
    const url = `${process.env.REACT_APP_API_ENDPOINT_BASE_URL}/api/thunderbolt/${slug}`;
    const cacheKey = `Localisations=${MD5(JSON.stringify(params))}`;

    dispatch({
      type,
    });

    const cachedValue = getDataFromCache(cacheKey);

    if (cachedValue !== null) {
      return dispatch({
        type: successType,
        payload: { data: cachedValue, params },
      });
    }

    return fetch(url, getRequestSettings('POST', params))
      .then((res) => {
        if (!res.ok) {
          throw Error(res.statusText);
        }

        return res.json();
      })
      .then((data) => {
        if (cache === true) {
          setDataInCache(cacheKey, data);
        }
        dispatch({
          type: successType,
          payload: { data, params },
        });
      })
      .catch((error) => {
        console.log(error);
        clearCache(cacheKey);
        dispatch({
          type: errorType,
          payload: error,
        });
      });
  };
}

export function getDataFromCache(cacheKey) {
  const cacheCookieExists = getCookie(cacheCookieKey);
  const toReturn = getCached(cacheKey);

  if (cacheCookieExists !== '') {
    return toReturn;
  }

  return null;
}

export function setDataInCache(cacheKey, data) {
  const cacheCookieExists = getCookie(cacheCookieKey) !== '';

  if (!cacheCookieExists) {
    // Create a cookie an hour in the future, used for refreshing cache on any long sessions
    const cacheExpiry = new Date();
    cacheExpiry.setHours(cacheExpiry.getHours() + 1);
    setCookie(cacheCookieKey, cacheExpiry.getTime(), cacheExpiry);
  }

  // update data in session storage
  setCached(cacheKey, data);
}

